module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.d2285965.ttf";